<template lang="pug">
#share-buttons.no-print(style='margin-bottom:10px;')
  a(
    v-if="facebookLink"
    style='text-decoration:none',
    :href='facebookLink'
  )
    img(
      src='/static/images/svg/facebook-logo.svg',
      width='30',
      height='30'
    )
  a(
    v-if="twitterLink"
    style='text-decoration:none',
    :href='twitterLink'
  )
    img(
      src='/static/images/svg/twitter-logo.svg',
      width='30',
      height='30'
    )
  a(
    v-if="mailLink"
    style='text-decoration:none',
    :href='mailLink'
  )
    img(
      src='/static/images/svg/mail-logo.svg',
      width='30',
      height='30'
    )
  a(
    style='text-decoration:none',
    href='javascript:window.print()'
  )
    img(
      src='/static/images/svg/print-logo.svg',
      width='30', height='30'
    )
  a(
    v-if="editLink"
    :href='EditLink',
    style='text-decoration:none', target='_blank'
  )
    img(
      height='30',
      src='/static/images/svg/edit-logo.svg',
      width='30'
    )
</template>

<script>
export default {
  props: [
    'facebookLink',
    'twitterLink',
    'mailLink',
    'editLink',
  ]
}
</script>

<style lang="stylus">
#share-buttons
  margin-top: 1em

</style>




// WEBPACK FOOTER //
// src/components/ShareButtons.vue